import React from 'react';
import { Button, ConfirmationModal, toastError, toastSuccess } from 'bench-internal-theme';
import { useMutation } from '@apollo/client';
import { useClient } from '../../../ClientContext';
import { Connection, ConnectionSource, NEW_INTEGRATION_SOURCES } from '../../types';
import { openModal } from 'modal-core-components';
import { RESET_CONNECTION, RESET_NEW_INTEGRATION } from '../../queries';
import { startCase } from 'lodash/string';
import refetchQueries from '../refetchQueries';

type ResetButtonProps = {
  connection: Connection;
};
const ResetButton = ({ connection }: ResetButtonProps) => {
  const { id: clientId } = useClient();

  const [reset, { loading }] = useMutation(RESET_CONNECTION, {
    awaitRefetchQueries: true,
    onCompleted: () => {
      toastSuccess('Connection', 'Connection was reset. Sync will be triggered automatically.');
    },
    onError: () => {
      toastError('Connection', 'There was a problem resetting the connection.');
    },
    refetchQueries: refetchQueries(clientId),
  });

  const formattedSource = startCase(connection.source.toLowerCase());

  const [resetNewIntegration, { loading: resetStripeSquareLoading }] = useMutation(
    RESET_NEW_INTEGRATION,
    {
      awaitRefetchQueries: true,
      onCompleted: () => {
        toastSuccess(
          'Connection',
          `Client's ${formattedSource} connection was reset. Sync will be triggered automatically.`,
        );
      },
      onError: () => {
        toastError(
          'Connection',
          `There was a problem resetting the client's ${formattedSource} connection.`,
        );
      },
      refetchQueries: refetchQueries(clientId),
    },
  );

  const onConfirm = () => {
    if (NEW_INTEGRATION_SOURCES.includes(ConnectionSource[connection.source])) {
      return resetNewIntegration({ variables: { connectionId: connection.id } });
    }
    return reset({
      variables: { connectionId: connection.id },
    });
  };

  const openConfirmationModal = () =>
    openModal(closeModal => (
      <ConfirmationModal
        closeModal={closeModal}
        onConfirm={onConfirm}
        description="This action will delete all collected data for this connection and start over? Ask BAS for guidance before running this!"
        title="Are you sure?"
      />
    ));

  return (
    <Button
      icon="refresh"
      disabled={loading || resetStripeSquareLoading}
      styleType="primary"
      onClick={openConfirmationModal}
    >
      Reset
    </Button>
  );
};

export default ResetButton;
